import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=26608067&scoped=true"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"

import "./ForgetPasswordPage.vue?vue&type=style&index=0&id=26608067&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26608067"

export default script